<template>
  <button
    :class="['neo-button', size, disabled ? 'disabled' : '']"
    :disabled="disabled"
  >
    <svg
      v-if="loading"
      class="loader"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="12" y1="2" x2="12" y2="6"></line>
      <line x1="12" y1="18" x2="12" y2="22"></line>
      <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
      <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
      <line x1="2" y1="12" x2="6" y2="12"></line>
      <line x1="18" y1="12" x2="22" y2="12"></line>
      <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
      <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
    </svg>
    <slot />
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M5 12h13M12 5l7 7-7 7" />
      </svg>
    </span>
  </button>
</template>

<script>
export default {
  name: "NeoButton",
  props: {
    size: {
      type: String,
      default: "regular",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.neo-button {
  padding: 8px 8px 8px 32px;
  border-radius: 100px;
  background: #121212;
  position: relative;
  color: #ffffff;
  font-size: 1rem;
  font-family: "Jost", sans-serif;
  font-weight: 500;
  display: flex;
  align-items: center;
  border: none;
  outline: none;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.25s ease-in;

  a {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }

  a,
  a:hover,
  a:focus {
    color: #ffffff;
    text-decoration: none;
  }

  span {
    margin-left: 15px;
    height: 28px;
    width: 28px;
    background: #ffffff;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.large {
    span {
      height: 36px;
      width: 36px;
    }
  }

  &.small {
    font-size: 0.8rem;
    padding: 6px 6px 6px 20px;

    span {
      height: 32px;
      width: 32px;
    }
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.2;
    transition: opacity 0.25s ease-in;

    a {
      z-index: -1;
    }
  }
}

.loader {
    margin-right: 7px;
    animation: rotate 2s linear infinite;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
